import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SchemaOrg, { makeOrganizationSchema, makeWebSiteSchema, makeWebPageSchema, makeFAQSchema } from '@/components/feature/SchemaOrg';
import { faqData } from '@/mocks/home';
import Hero from './components/Hero';
import CategoryNav from './components/CategoryNav';
import FeaturedList from './components/FeaturedList';
import ArticleList from './components/ArticleList';
import ResourceNav from './components/ResourceNav';
import FAQ from './components/FAQ';
import CTASection from './components/CTASection';

const SUBMIT_ADDR = 'https://readdy.ai/api/form/d9otroiftmtnfcfh0e50';

export default function Home() {
  return (
    <>
      <SchemaOrg {...makeOrganizationSchema()} />
      <SchemaOrg {...makeWebSiteSchema()} />
      <SchemaOrg {...makeWebPageSchema(
        '韩国漫画网-免费韩漫大全-漫画韩漫网址-韩漫在线阅读',
        '免费韩漫大全，漫画网址，韩漫在线阅读，资源导航，便捷访问。通过此漫画网址可便捷访问免费韩漫大全。',
        'https://www.example.com/',
      )} />
      <SchemaOrg {...makeFAQSchema(faqData)} />
      <Navbar />
      <main>
        <Hero />
        <CategoryNav />
        <FeaturedList />
        <ResourceNav />
        <ArticleList />
        <FAQ />
        <CTASection submitAddr={SUBMIT_ADDR} />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}